import { useParams } from 'react-router-dom';
import { useAppSelector } from '@store';
import useTopUpOptions from './hooks/use-top-up-otions';
import TopUpOptionsComponent from '../../../components/common/top-up/options';
import { TopUpOptionsTypes } from './types';

const TopUpOptions = ({
  setTopUpPanelIsOpen,
  setSelectedTopUpId,
  status,
  customerType,
}: TopUpOptionsTypes) => {
  const { customerId } = useParams();

  const {
    topUpOptions,
    topUpOptionsPagination,
    topUpIds,
    topUpVisibility,
    topUpIsLoading,
  } = useAppSelector((state) => state.topUpPanel);
  const { activePermissions } = useAppSelector((state) => state.root);

  const {
    selectedTopUpOptionId,
    setSelectedTopUpOptionId,
    addTopUpOptionVisibilityIsSuccess,
    updateTopUpOptionVisibilityIsSuccess,
    addVisibilityAction,
    updateVisibiliyAction,
    getNextTopUpOptions,
    topUpOptionsIsLoading,
    topUpOptionsIsFetching,
    topUpVisibilityIsLoading,
    topUpVisibilityIsFetching,
  } = useTopUpOptions({
    customerId,
    topUpIds,
    topUpOptions,
  });

  return (
    <TopUpOptionsComponent
      topUpOptions={topUpOptions}
      isLoading={topUpIsLoading}
      customerType={customerType}
      setTopUpPanelIsOpen={setTopUpPanelIsOpen}
      setSelectedTopUpId={setSelectedTopUpId}
      topUpOptionsPagination={topUpOptionsPagination}
      getNextTopUpOptions={getNextTopUpOptions}
      topUpOptionsIsLoading={topUpOptionsIsLoading || topUpOptionsIsFetching}
      status={status}
      topUpVisibility={topUpVisibility}
      topUpVisibilityIsLoading={
        topUpVisibilityIsLoading || topUpVisibilityIsFetching
      }
      selectedTopUpOptionId={selectedTopUpOptionId}
      setSelectedTopUpOptionId={setSelectedTopUpOptionId}
      addTopUpOptionVisibilityIsSuccess={addTopUpOptionVisibilityIsSuccess}
      updateTopUpOptionVisibilityIsSuccess={
        updateTopUpOptionVisibilityIsSuccess
      }
      addVisibilityAction={addVisibilityAction}
      updateVisibiliyAction={updateVisibiliyAction}
      activePermissions={activePermissions}
    />
  );
};

export default TopUpOptions;
